// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"a7ffb97a","316":"a7ffb97a","369":"cfa5cb84","448":"a7ffb97a","764":"a7ffb97a"}[chunkId] + ".chunk.css";
};